export default {
  initial_stock: "Estoque Inicial",
  sale: "Venda",
  purchase: "Compra",
  inventory: "Inventário",
  manual_input: "Entrada Manual",
  manual_output: "Saída Manual",
  return: "Devolução"
};



// WEBPACK FOOTER //
// ./src/core/enum/stock-operations-activity.enum.js